import { ImportResultsRecord } from '@components/bid_request/details/types';
import { DEFAULT_LOT_NAME } from '@components/bid_request/details/constants';

/**
 * This function takes a row of data and returns the columns and lot name.
 * @param rowData
 * @returns [{}, string]
 */
export const getColumnsAndLotNameFromRow = (rowData: ImportResultsRecord) => {
  const rowColumns = { ...rowData };

  if (!rowColumns.lot_name || !rowColumns.lot_name.trim()) { rowColumns.lot_name = DEFAULT_LOT_NAME; }
  rowColumns.lotName = rowColumns.lot_name;

  const lotName = rowColumns.lot_name;

  delete rowColumns.lot_name;
  return [rowColumns, lotName];
};
